import { useState } from "react";

export default function TextHoverComponent({ cssClass, children, onMouseEnter, onMouseLeave }) {
    const [delayHandler, setDelayHandler] = useState(null);

    const handleMouseEnter = () => {
        setDelayHandler(setTimeout(() => {
            onMouseEnter();
        }, 500))
    }

    const handleMouseLeave = () => {
        clearTimeout(delayHandler);
        onMouseLeave();
    }
    return (
        <div className={cssClass}
            onMouseEnter={() => handleMouseEnter()}
            onMouseLeave={() => handleMouseLeave()}
        >
            {children}
        </div>
    )
}